import { Component, Input, OnInit } from '@angular/core';
import { ServiceService } from 'src/app/services/service.service';

@Component({
  selector: 'app-station-tank-levels',
  templateUrl: './station-tank-levels.component.html',
  styleUrls: ['./station-tank-levels.component.css', '../../../../scrollbar.scss']
})
export class StationTankLevelsComponent implements OnInit {

  @Input() stations;
  @Input() isContainer;
  selectedItems = [];
  selectedItem;

  constructor(private service: ServiceService) { }

  ngOnInit(): void {
    console.log("Stations", this.stations);
    this.stations.forEach(element => {
      this.openModalForDetails(element, element);
    });
  }


  public openModalForDetails(item: any, station): void {
    this.service.findDealerAndStationDetails(item.locationID + ':' + item.tenant).subscribe(res => {
      this.selectedItem = res;
      this.selectedItem.billtype = item.billtype;
      this.selectedItem.tac = item.tac;
      let uniqueTanks = [];
      this.selectedItem.tblTanks.forEach(tblTank => {
        // const selectedIndex = uniqueTanks?.findIndex((tank) => tank?.tankName === tblTank?.tankName)
        tblTank.counterTemp = tblTank.counter;
        // if (selectedIndex == -1) {
          uniqueTanks.push(tblTank);
          // console.log("Tanks", tblTank);
        // } else {
        //   uniqueTanks[selectedIndex].counterTemp += ":" + tblTank.counterTemp;
        // }
      })

      this.selectedItem.tblTanksTemp = uniqueTanks;
      this.selectedItem.station = station;
      console.log("Selected Tank ans station data", this.selectedItem);
      this.selectedItems.push(this.selectedItem);
      for (let i = 0; i < this.selectedItem.tblTanksTemp.length; i++) {

        let tank = this.selectedItem.tblTanksTemp[i];
        let tblReading: any = {
          'tankid': this.selectedItem.tblTanksTemp[i].counter,
          'gallons': null,
          'productName': this.selectedItem.tblTanksTemp[i].tankName,
          'tenant': JSON.parse(localStorage.getItem("user-tenant")).tenantId,
          'updatesource': 'WEB',
        }
        let todayFound = false;
      }
    });
  }

}
